import React, {useEffect, useState} from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import IconPromo from "../../../assets/img/icon/news-feed-ic-promo.svg";
import ChevronRight from "../../../assets/img/icon/chevron-right.svg";
import {postDanai} from "../../util/ajax";
import {Link} from "react-router-dom";
import Moment from 'moment';

export default function PromoSlider() {
    const settings = {
        dots: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: 1920,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 853,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const [promoEvent, setPromoEvents] = useState([])
    useEffect(() => {
        postDanai(process.env.REACT_APP_MOBILE_API_URL + '/p2p-mobile-api/rest/customerWeb/promoEvents', function (resp) {
            console.log(resp);
            setPromoEvents(resp.data);
        }, function () {
        });
    }, []);
    const filteredPromoEvent = promoEvent.filter((promo) =>
        promo.priority === 1
    );

    const lengthPromoEvent = filteredPromoEvent.length;

    return (
        <div className="container-8">
            <div className="section-title">
                <h2 className="text-header">Promosi, Kegiatan, & Berita Seputar <span>Danai.id</span></h2>
                <p>Temukan penawaran dan informasi menarik dari kami disini.</p>
            </div>
            <div className="news-feed">
                <div className="general-container">
                    <Slider {...settings}>
                        {Array.from({length: lengthPromoEvent}).map((_, index) => (
                            <div className="news-feed-item-wrapper ui-g"
                                 key={filteredPromoEvent[index].id || index}>
                                <Link className="news-feed-item" to={{
                                    pathname: 'promo-detail',
                                    search: `?id=${filteredPromoEvent[index].id}`,
                                }} preventScrollReset={true} rel="noreferrer">
                                    <div className="img-promo">
                                        <img src={filteredPromoEvent[index].imageUrl} alt="promo"/>
                                    </div>
                                    <div className="text-promo">
                                        <div className="space-between">
                                            <div
                                                className={`category-promo ${filteredPromoEvent[index].category === 'Informasi' ? 'informasi' : ''} gap-1`}>
                                                <img src={IconPromo} alt="icon category"/>
                                                <p className="text-category text-blue-700 m-0">{filteredPromoEvent[index].category}</p>
                                            </div>
                                            <div className="timestamp">
                                                <p className="text text-green-800 m-0">{Moment(filteredPromoEvent[index].createdTimestamp).format('DD MMMM yyyy')}</p>
                                            </div>
                                        </div>
                                        <p className="text">{filteredPromoEvent[index].title}</p>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </Slider>
                    <div className="container-learn-more">
                        <a className="learn-more-link" href="media-informasi"> Lihat Selengkapnya<img src={ChevronRight}
                                                                                                      alt="chevron-right"/></a>
                    </div>
                </div>
            </div>
        </div>
    )
}